import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import config,{formatJalaliToGregorian} from '../config/staticData';

const SEOPAGE = ({ blogId, title, description, body, image, video, videoDuration, publishDate, ratingValue }) => {
  const imageUrl = `https://www.toorangco.com${process.env.REACT_APP_BASE_PATH}${config.blogPath}${image}`;
  const videoUrl = `https://www.toorangco.com${process.env.REACT_APP_BASE_PATH}${config.videoPath}${video}`;
  const location = useLocation();
  const currentUrl = `https://www.toorangco.com${location.pathname}`;
  const descriptionSEO = (description === '' || description == null) ? "فروشگاه اینترنتی تورنگ" : description;

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": descriptionSEO,
    "image": imageUrl,
    "author": {
      "@type": "Organization",
      "name": "فروشگاه اینترنتی تورنگ"
    },
    "publisher": {
      "@type": "Organization",
      "name": "فروشگاه اینترنتی تورنگ",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.toorangco.com/images/logo.png"
      }
    },
    "url": currentUrl,
    "datePublished": formatJalaliToGregorian(publishDate),
    "dateModified": formatJalaliToGregorian(publishDate)
  };

  if (video) {
    schemaData.video = {
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": title,
      "description": descriptionSEO,
      "thumbnailUrl": [imageUrl],
      "uploadDate": formatJalaliToGregorian(publishDate),
      "duration": `PT${videoDuration}`,
      "contentUrl": videoUrl,
      "embedUrl": videoUrl
    };
  }

  return (
      <Helmet>
          <script type="application/ld+json">
              {JSON.stringify(schemaData)}
          </script>
      </Helmet>
  );
};


export default SEOPAGE;


const HELMETSEO = ({ title, description, keyword}) => {
  const location = useLocation();
  const currentUrl = `https://www.toorangco.com${location.pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta name="twitter:description" content={description} />
      <meta name="keywords" content={keyword} />
      <meta property="og:image" content="https://www.toorangco.com/images/logo.png" />
      <meta name="twitter:image" content="https://www.toorangco.com/images/logo.png" />
      <meta property="og:url" content={currentUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="preload" as="image" href="https://www.toorangco.com/images/logo.png" />
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};
export { HELMETSEO };

const BREADSEO = ({ title, pageUrl}) => {
    const breadData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "خانه",
          "item": `https://www.toorangco.com${process.env.REACT_APP_BASE_PATH}`
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": title,
          "item": `https://www.toorangco.com${pageUrl}`
        }
      ]
    }

  return (
    <Helmet>
      <script type="application/ld+json">
          {JSON.stringify(breadData)}
      </script>
    </Helmet>
  );
};
export { BREADSEO };